import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

import { GlobalFilterContext } from './context';

export const withGlobalFilter = (WrappedComponent) => {
  const HoC = props => (
    <GlobalFilterContext.Consumer>
      {
        filterContext =>
          (<WrappedComponent
            {...props}
            {...filterContext}
          />)
      }
    </GlobalFilterContext.Consumer>
  );

  HoC.displayName = `withGlobalFilter(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
